/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeApi, URLS } from "Utils/apiURL";

const HubspotOAuth = () => {
  const [isConnected, setConnected] = useState(false);

  const getHubspotAuthAccountsInfo = () => {
    try {
      const url = new URL(window.location.href);
      const code = url?.searchParams.get("code");
      !code
        ? url?.href?.indexOf("access_denied") !== -1
          ? closeWindow()
          : ""
        : "";
      return { code };
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const connectHubspotApp = async () => {
    const { code = "" } = getHubspotAuthAccountsInfo();
    try {
      if (code) {
        const config = {
          url: `${URLS.connectOrDisconnectHubspot}?code=${code}`,
          method: "POST"
        };
        const res = await makeApi(config);
        const resCode = res?.data?.code?.toString() || "500";
        const messagePayload = {
          code: resCode,
          type: "HUBSPOT_CONNECT_APP",
          connectedCrm: res?.data?.connectedCrm
        };

        try {
          if (window.opener) {
            window.opener.postMessage(messagePayload, "*");
          }
        } catch (e) {
          console.error("postMessage error", e);
        }

        try {
          if (typeof BroadcastChannel !== "undefined") {
            const bc = new BroadcastChannel("crm_auth_conn");
            bc.postMessage(messagePayload);
            bc.close();
          }
        } catch (e) {
          console.error("BroadcastChannel error", e);
        }

        if (resCode === "200") {
          setConnected(true);
          setTimeout(() => {
            closeWindow();
          }, 1000);
        } else {
          closeWindow();
        }
      } else {
        closeWindow();
      }
    } catch (err) {
      console.error(err);
      closeWindow();
    }
  };

  const closeWindow = () => {
    window?.close();
  };

  useEffect(() => {
    connectHubspotApp();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          {isConnected ? (
            <div>Successfully Connected</div>
          ) : (
            <div>
              <div>Please wait while we connect your Hubspot account</div>
              <div style={{ marginTop: "10px" }}> Connecting... </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HubspotOAuth;
export { HubspotOAuth };
